import { Routes } from '@angular/router';

import { LayoutPrincipalComponent } from '@shared/components/layout-principal/layout-principal.component';

import { AdminConfiguracaoComponent } from './configuracao/admin-configuracao.component';

export const ADMIN_CONFIGURACAO_ROUTES: Routes = [
  {
    path: '',
    component: LayoutPrincipalComponent,
    children: [
      {
        path: '',
        component: AdminConfiguracaoComponent,
      },
      {
        path: 'criterios',
        loadChildren: () =>
          import('../criterio/criterio.router').then(
            (m) => m.ADMIN_CRITERIOS_ROUTES
          ),
      },
      {
        path: 'criterios-calculados',
        loadChildren: () =>
          import('../criterio-calculado/criterio-calculado.router').then(
            (m) => m.ADMIN_CRITERIOS_CALCULADOS_ROUTES
          ),
      },
      {
        path: 'periodos',
        loadChildren: () =>
          import('../periodo/periodo.router').then(
            (m) => m.ADMIN_PERIODOS_ROUTES
          ),
      },
    ],
  },
];
